import React, { useEffect, useRef } from 'react';
import SlickCarousel from '../../../../../common/slickCarousel/slickCarousel';
import { ALL } from '../../../../../common/commonConstant';
import './FoodCategoryCarousel.scss';

const FoodCategoryCarousel = ({ data = [], selectedCategory, onClick = () => { } }) => {
  const SliderRef = useRef(null);

  useEffect(() => {
    if(!SliderRef.current || !data.length) return;

    const indexToSlide = Math.max(data.findIndex(category => category.id === selectedCategory.id), 0);
    const targetIndex = data.length > 1 && selectedCategory.id === ALL ? Math.max(indexToSlide - 1, 0) : indexToSlide;
     
    SliderRef.current.slickGoTo(targetIndex);
  }, [selectedCategory.id, data.length]);

  
  return <SlickCarousel slidesToShow={4} ref={SliderRef}>
    {data.map((item) => {
      return <div key={item?.id}
        onClick={(event) => onClick(item, event)}
        className={`category-card${selectedCategory.id === item?.id ? ' category-card-active' : ''}`}>
        <div className="category-img-container">
          <img src={item?.imageUrl} />
        </div>
        <div className="category-card-title">
          {item?.name}
        </div>
      </div>
    })}
  </SlickCarousel>
};

export default FoodCategoryCarousel;
